import React from 'react';
import { Link } from 'react-router-dom';
import { useModalsContext } from '/src/providers';
import { Table } from '/src/components';
import * as styles from './styles.scss';

const OrdersTable = ({
    data,
    reOrder,
    translate,
    formatDate,
    formatPrice,
}) => {
    const { showModal, MODALS_TYPES } = useModalsContext();

    const labels = [
        translate('Order'),
        translate('Date'),
        translate('Total'),
        translate('Status'),
        translate('Action'),
    ];
    const columns = [
        { key: 'order_number', label: translate('Order') },
        { key: 'created_at', label: translate('Date') },
        { key: 'grand_total', label: translate('Total') },
        { key: 'status', label: translate('Status') },
        { key: 'action', label: translate('Action') }
    ];

    const rows = data.map(({
        order_number,
        created_at,
        total: { grand_total },
        status
    }) => ({
        order_number,
        created_at: formatDate(created_at),
        grand_total: formatPrice(grand_total),
        status,
        action: (
            <div className={styles.actions}>
                <Link
                    to={`/customer/orders/${order_number}`}
                >
                    {translate('View')}
                </Link>
                <button
                    onClick={
                        () => reOrder({ orderNumber: order_number })
                            .catch(errors => showModal(MODALS_TYPES.ERROR, { errors }))
                    }
                >
                    {translate('Reorder')}
                </button>
            </div>
        )
    }));

    return (
        <Table
            rowClassName={styles.orders}
            columns={columns}
            rows={rows}
            labels={labels}
        />
    )
};

export default OrdersTable;
